import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { SignInPageService } from '@/pages/SignIn/services';
import toast from 'react-hot-toast';

const MODULE_NAME = 'profile.machines.states.setActive';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

export const changePassword = async (context: any, event: any) => {
  const currentState = 'CHANGE_PASSWORD';
  const method = 'setActive';

  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.changePassword(event?.payload);
      console.log(content);
      if (content) {
        // return {
        //   type: 'RENDER_ACCOUNT_SELECTION',
        //   PASSWORD_RECENTLY_UPDATED: true,
        //   value: content,
        // };
        return resolve({
          key: 'RENDER_ACCOUNT_SELECTION',
          PASSWORD_RECENTLY_UPDATED: true,
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Change password failed';
        // toast.error(msg);
        return Promise.reject({
          type: 'CHANGE_PASSWORD_FAILED',
          value: msg, // ✅ use msg, not undefined content
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'CHANGE_PASSWORD_FAILED',
        value: _msg,
      });
    }
  });
};
